import React, { useState } from 'react';
import {
    Box,
    Button,
    Tab,
    Tabs,
    Typography,
    Paper,
    InputBase,
    IconButton
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Link, useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';



import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SettingsIcon from '@mui/icons-material/Settings';

import EditProject from '../../../components/Projects/EditProject';
import DuplicateProject from '../../../components/Projects/DuplicateProject';
import TransferProjectTesting from '../../../components/Projects/TransferProjectTesting';
import ArchivTheProjects from '../../../components/Projects/ArchivTheProjects';
import ProjectsDetailsTable from './ProjectsDetailsTable';



function CustomTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const organizeOptions = ['Date', 'Project', 'Member'];

const ProjectDetails = () => {
    const navigate = useNavigate();
    const [openEditProject, setOpenEditProject] = useState(false);
    const [openDuplicate, setOpenDuplicate] = useState(false);
    const [openTransfer, setOpenTransfer] = useState(false);

    const [openArchivTheProjects, setOpenArchivTheProjects] = useState(false);

    return (
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Button
                    onClick={() => navigate('/my-projects')}
                    style={{
                        color: '#1A1F36',
                        fontSize: '24px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        marginBottom: '24px',
                        fontFamily: 'Manrope',
                        padding: '0',
                        marginLeft: '-10px'

                    }}
                >
                    <KeyboardArrowLeftIcon
                        sx={{ color: '#1760EC', width: '30px', height: '30px' }}
                    />
                    Project
                </Button>
                <Link to='/feature'>
                    <Button sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '16px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}><SettingsIcon /></Button>
                </Link>
            </Box>

            <Box sx={{ border: '1px solid #DFDFDF', backgroundColor: '#FFFFFF', borderRadius: '8px', p: '24px 32px' }}>
                <   Box display="flex" justifyContent="space-between" alignItems="center" sx={{ flexWrap: 'wrap' }}>
                    <Box display="flex" alignItems="center" sx={{ gap: '20px', marginBottom: '10px' }}>
                        <Box sx={{ backgroundColor: '#FF8328', border: '2px solid #FFFFFF', height: '72px', width: '72px', fontSize: '24px', fontWeight: '500', color: '#FFFFFF', p: '18px', lineHeight: '1.5', borderRadius: '100px', boxShadow: '0 3px 8px #00000040', textAlign: 'center' }}>CB</Box>
                        <Box display="flex" alignItems="center" sx={{ gap: { xl: '48px', lg: '30px', md: '20px', sm: '20px', xs: '48px' } }}>
                            <Box>
                                <Typography sx={{ fontSize: '20px', color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope' }}>Creative Boost</Typography>
                                <Typography sx={{ fontSize: '14px', color: '#64748B', fontWeight: '400', fontFamily: 'Manrope' }}>Worked Desk 2</Typography>
                            </Box>
                            <Typography sx={{ fontSize: '14px', color: '#00831E', fontWeight: '500', fontFamily: 'Manrope', border: '1px solid #179046', backgroundColor: '#1790453D', height: '36px', width: '82px', textAlign: 'center', lineHeight: '2.4', borderRadius: '50px' }}>Active</Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                        <Button onClick={() => setOpenEditProject(true)} component="label" variant="contained" sx={{ padding: { xl: '6px 16px', lg: '6px 16px', md: '6px 10px', sm: '6px 10px', xs: '6px 16px' }, gap: '8px', borderRadius: '50px', fontSize: { xl: '14px', lg: '14px', md: '12px', sm: '12px', xs: '14px' }, background: '#0076FE', border: '1px solid #0076FE', color: '#fff', boxShadow: 'none', fontFamily: 'Manrope' }}
                            tabIndex={-1}>
                            <img src='./assets/images/app-activity/edit-icon.svg' className='img-fluid' alt='edit icon' style={{ height: '14px' }} />
                            Edit</Button>

                        <Button onClick={() => setOpenDuplicate(true)} component="label" variant="contained" sx={{ padding: { xl: '6px 16px', lg: '6px 16px', md: '6px 10px', sm: '6px 10px', xs: '6px 16px' }, gap: '8px', borderRadius: '50px', fontSize: { xl: '14px', lg: '14px', md: '12px', sm: '12px', xs: '14px' }, background: '#fff', border: '1px solid #0076FE', color: '#0084FF', boxShadow: 'none', fontFamily: 'Manrope' }}
                            tabIndex={-1}
                        // startIcon={<ShareIcon />}
                        ><img src='./assets/images/app-activity/duplicate-icon.svg' className='img-fluid' alt='duplicate icon' />
                            Duplicate</Button>

                        <Button onClick={() => setOpenTransfer(true)} component="label" variant="contained" sx={{ padding: { xl: '6px 16px', lg: '6px 16px', md: '6px 10px', sm: '6px 10px', xs: '6px 16px' }, gap: '8px', borderRadius: '50px', fontSize: { xl: '14px', lg: '14px', md: '12px', sm: '12px', xs: '14px' }, background: '#fff', border: '1px solid #0076FE', color: '#0084FF', boxShadow: 'none', fontFamily: 'Manrope' }}
                            tabIndex={-1}
                        // startIcon={<ScheduleIcon />}
                        ><img src='./assets/images/app-activity/transfer-icon.svg' className='img-fluid' alt='transfer icon' />
                            Transfer</Button>

                        <Button onClick={() => setOpenArchivTheProjects(true)} component="label" variant="contained"
                            sx={{ padding: { xl: '6px 16px', lg: '6px 16px', md: '6px 10px', sm: '6px 10px', xs: '6px 16px' }, gap: '8px', borderRadius: '50px', fontSize: { xl: '14px', lg: '14px', md: '12px', sm: '12px', xs: '14px' }, background: '#fff', border: '1px solid #0076FE', color: '#0084FF', boxShadow: 'none', fontFamily: 'Manrope' }}
                            tabIndex={-1}
                        // startIcon={<ExportIcon />}
                        ><img src='./assets/images/app-activity/archive-icon.svg' className='img-fluid' alt='archive icon' />
                            Archive</Button>


                    </Box>
                </Box>
                {/* === */}
                <Box display="flex" alignItems="center" sx={{ pt: 2, gap: { xl: '70px', lg: '50px', md: '20px', sm: '14px', xs: '20px' }, flexWrap: 'wrap' }}>
                    <Box display="flex" alignItems="center" sx={{ gap: { xl: '8px', lg: '8px', md: '8px', sm: '4px', xs: '4px' }, whiteSpace: 'nowrap' }}>
                        <Typography sx={{ fontSize: { xl: '14px', lg: '14px', md: '14px', sm: '14px', xs: '14px' }, color: '#64748B', fontWeight: '400', fontFamily: 'Manrope' }}>Client:</Typography>
                        <Typography display="flex" alignItems="center" sx={{ gap: '8px', fontSize: { xl: '16px', lg: '16px', md: '16px', sm: '15px', xs: '12px' }, color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>
                            <img src="https://www.google.com/s2/favicons?sz=64&domain_url=https://acadecraft.com" alt='acadecraft' className='img-fluid'
                                style={{ width: '32px', height: '32px', backgroundSize: 'cover', objectFit: 'cover', borderRadius: '100px' }} />
                            Acadecraft</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" sx={{ gap: { xl: '8px', lg: '8px', md: '8px', sm: '4px', xs: '4px' }, whiteSpace: 'nowrap' }}>
                        <Typography sx={{ fontSize: { xl: '14px', lg: '14px', md: '14px', sm: '14px', xs: '14px' }, color: '#64748B', fontWeight: '400', fontFamily: 'Manrope' }}>Last Active: </Typography>
                        <Typography display="flex" alignItems="center" sx={{ gap: '8px', fontSize: { xl: '16px', lg: '16px', md: '16px', sm: '15px', xs: '12px' }, color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>Thu, May 1, 2025 6:10 pm</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" sx={{ gap: { xl: '8px', lg: '8px', md: '8px', sm: '4px', xs: '4px' }, whiteSpace: 'nowrap' }}>
                        <Typography sx={{ fontSize: { xl: '14px', lg: '14px', md: '14px', sm: '14px', xs: '14px' }, color: '#64748B', fontWeight: '400', fontFamily: 'Manrope' }}>Billable:</Typography>
                        <Typography display="flex" alignItems="center" sx={{ gap: '8px', fontSize: { xl: '16px', lg: '16px', md: '16px', sm: '15px', xs: '12px' }, color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>
                            No <Button onClick={() => setOpenEditProject(true)} sx={{
                                minWidth: '24px', width: '24px', height: '24px', color: '#0076FE', border: '1px solid #0076FE', borderRadius: '100px', textAlign: 'center',
                                lineHeight: '1.1'
                            }}><ModeEditIcon sx={{ fontSize: '14px' }} /></Button></Typography>
                    </Box>

                    <Box display="flex" alignItems="center" sx={{ gap: { xl: '8px', lg: '8px', md: '8px', sm: '4px', xs: '4px' }, whiteSpace: 'nowrap' }}>
                        <Typography sx={{ fontSize: { xl: '14px', lg: '14px', md: '14px', sm: '14px', xs: '14px' }, color: '#64748B', fontWeight: '400', fontFamily: 'Manrope' }}>Budget:</Typography>
                        <Typography display="flex" alignItems="center" sx={{ gap: '8px', fontSize: { xl: '16px', lg: '16px', md: '16px', sm: '15px', xs: '12px' }, color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>
                            None <Button onClick={() => setOpenEditProject(true)} sx={{
                                minWidth: '24px', width: '24px', height: '24px', color: '#0076FE', border: '1px solid #0076FE', borderRadius: '100px', textAlign: 'center',
                                lineHeight: '1.1'
                            }}><ModeEditIcon sx={{ fontSize: '14px' }} /></Button></Typography>
                    </Box>

                </Box>

            </Box>


            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ margin: '32px auto' }}>
                <Typography variant="h6" fontWeight="600" sx={{ fontFamily: 'Manrope', }}>
                    Members
                </Typography>
                <Box className="d-flex gap-10 align-items-center">
                    <Paper component="form" sx={{ display: 'flex', alignItems: 'center', width: '300px', height: '38px', borderRadius: '100px', boxShadow: 'unset', border: '1px solid #E5E8EB' }}>
                        <IconButton type="button" aria-label="search"><SearchIcon sx={{ fontSize: '20px', color: '#64748B' }} /></IconButton>
                        <InputBase sx={{ ml: 0, flex: 1, fontSize: '14px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope' }} placeholder="Search Projects" inputProps={{ 'aria-label': 'Search Projects' }} />
                    </Paper>
                    {/* Widgets & Scheduled Button */}
                    <Button
                        variant="contained"
                        sx={{
                            borderRadius: '30px',
                            textTransform: 'capitalize',
                            fontSize: { xl: '14px', lg: '14px', md: '12px', sm: '12px', xs: '14px' },
                            padding: '8px 16px',
                            background: '#0076FE',
                            fontFamily: 'Manrope',
                            height: '36px',
                            border: 'none',
                            boxShadow: 'none'
                        }}
                        onClick={() => setOpenEditProject(true)}
                    >
                        Edit Members
                    </Button>

                </Box>
            </Box>
            <ProjectsDetailsTable />

            <EditProject open={openEditProject} onClose={() => setOpenEditProject(false)} />
            <DuplicateProject open={openDuplicate} onClose={() => setOpenDuplicate(false)} />
            <TransferProjectTesting open={openTransfer} onClose={() => setOpenTransfer(false)} />
            <ArchivTheProjects open={openArchivTheProjects} onClose={() => setOpenArchivTheProjects(false)} />
        </>
    );
};

export default ProjectDetails;
